module.exports = __webpack_public_path__ + "static/media/IMG_4269.d60bbb9b.PNG";